import React from 'react';
import { Link } from 'react-router-dom';
import '../../../Auth.css';
import AuthLeftBranding from './AuthLeftBranding';
import AuthLandingFooter from './AuthLandingFooter';
import AuthBackToHome from './AuthBackToHome';

export default function LegalPageLayout({ title, children }) {
  return (
    <div className="login-main login-main--landing-footer">
      <div className="login-main-split">
        <div className="left-div">
          <AuthBackToHome placement="bluePanel" />
          <AuthLeftBranding />
        </div>

        <div className="login-container signup-plans-left legal-page-panel">
          <h2>{title}</h2>
          <div className="legal-page-content">{children}</div>
          <div className="signup-bottom signup-bottom--register">
            <Link to="/register" className="signup-link">
              Back to Sign Up
            </Link>
          </div>
        </div>
      </div>

      <AuthLandingFooter />
    </div>
  );
}
